import React, { useState, useEffect } from 'react';
import Header from '../homepage/header'; // Adjust the path if needed
import { API_BASE } from '../../apiConfig';
import peopleData from './people.json';
import './People.css';

const PEOPLE_CATEGORIES = [
  'Professor In-charge',
  'Project Staff',
  'PhD',
  'M.Tech (By Research)',
  'M.Tech',
  'B.Tech',
  'Interns',
  'Alumni',
  'Past Contributors'
];

function People() {
  const [peopleList, setPeopleList] = useState({});
  const [expandedSections, setExpandedSections] = useState({});

  useEffect(() => {
    fetch(`${API_BASE}/people`)
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then((data) => setPeopleList(data))
      .catch((err) => {
        console.log("Failed fetching dynamic people, falling back to static:", err);
        setPeopleList(peopleData);
      });
  }, []);

  const toggleSection = (category) => {
    setExpandedSections((prevSections) => ({
      ...prevSections,
      [category]: !prevSections[category],
    }));
  };

  return (
    <div>
      <Header />
      <div className="header-container">
        <h1>Contributors</h1>
      </div>
      <div className="people-container">
        {PEOPLE_CATEGORIES.map((category) => {
          const people = peopleList[category];
          if (!people || people.length === 0) return null;
          return (
            <div key={category} className="category">
              <h2 onClick={() => toggleSection(category)} className="expandable-heading">
                {category}
                <span className={`chevron ${expandedSections[category] ? 'rotate' : ''}`}>
                  {expandedSections[category] ? '▲' : '▼'}
                </span>
              </h2>

              {expandedSections[category] && (
                <>
                  {category === "Past Contributors" ? (
                    <div className="alumni-grid">
                      {people.map((person, index) => (
                        <div key={index} className="alumni-card">
                          {person.name}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="people-grid">
                      {people.map((person, index) => (
                        <div className="person" key={index}>
                          <img className="profile-photo" src={person.image || "https://placehold.co/150"} alt={person.name} />
                          <div>
                            <h3>{person.name}</h3>
                            {person.designation && <p>{person.designation}</p>}
                            {person.researchInterests && (
                              <div className="research-interests">
                                <span>Research Interests:</span> {person.researchInterests}
                              </div>
                            )}
                            {person.projectInvolved && (
                              <div className="project-interests">
                                <span>Project Involved:</span> {person.projectInvolved}
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default People;
